import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './FloorPlan.css';

// Images import
import floor1 from '../../assets/images/floor1.png';
import floor2 from '../../assets/images/floor2.png';

const FloorPlan = () => {
  const [activeTab, setActiveTab] = useState('first');

  const data = {
    first: {
      title: "1st, 8th & 13th Floor Plan",
      img: floor1, // Variable use kiya hai
      table: [
        { type: '2 BHK', numbers: '101, 104, 801, 804, 1301, 1304', rera: '57.11', encl: '12.62', bal: '6.92', total: '76.65', sqft: '825' },
        { type: '2.5 BHK', numbers: '102, 103', rera: '72.22', encl: '12.52', bal: '8.02', total: '92.76', sqft: '998' },
      ]
    },
    typical: {
      title: "Typical Floor Plan",
      img: floor2, // Variable use kiya hai
      table: [
        { type: '2.5 BHK', numbers: '201, 301, 401, 501, 601, 701, 901, 1001, 1101, 1201', rera: '69.53', encl: '12.62', bal: '10.49', total: '92.64', sqft: '997' },
        { type: '3 BHK', numbers: '202, 302, 402, 502, 602, 702, 802, 902, 1002, 1102, 1202, 1302', rera: '72.41', encl: '12.62', bal: '10.49', total: '95.52', sqft: '1028' },
        { type: '3 BHK', numbers: '203, 303, 403, 503, 603, 703, 803, 903, 1003, 1103, 1203, 1303', rera: '72.41', encl: '12.62', bal: '10.49', total: '95.52', sqft: '1028' },
        { type: '3 BHK', numbers: '204, 304, 404, 504, 604, 704, 904, 1004, 1104, 1204', rera: '72.25', encl: '13.00', bal: '10.49', total: '95.36', sqft: '1026' },
      ]
    }
  };

  return (
    <section className="floor-plan-section">
      <div className="floor-plan-wrapper">
        
        {/* Tab Switcher */}
        <div className="tab-container">
          <button 
            className={`tab-btn ${activeTab === 'first' ? 'active' : ''}`}
            onClick={() => setActiveTab('first')}
          >
            1st, 8th & 13th Floor
          </button>
          <button 
            className={`tab-btn ${activeTab === 'typical' ? 'active' : ''}`}
            onClick={() => setActiveTab('typical')}
          >
            Typical Floor Plan
          </button>
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, scale: 0.98, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.98, y: -10 }}
            transition={{ duration: 0.4, ease: "easeInOut" }}
          >
            <h2 className="plan-title">{data[activeTab].title}</h2>

            <div className="plan-image-container">
              <img 
                src={data[activeTab].img} 
                alt={data[activeTab].title} 
                className="floor-plan-img"
              />
            </div>

            <div className="table-responsive">
              <table className="plan-table">
                <thead>
                  <tr>
                    <th>TYPE</th>
                    <th>FLAT NUMBER</th>
                    <th>RERA CARPET</th>
                    <th>ENCL. BALCONY</th>
                    <th>BALCONY</th>
                    <th>TOTAL CARPET</th>
                    <th>TOTAL CARP SQ.FT.</th>
                  </tr>
                </thead>
                <tbody>
                  {data[activeTab].table.map((row, index) => (
                    <tr key={index}>
                      <td>{row.type}</td>
                      <td>{row.numbers}</td>
                      <td>{row.rera}</td>
                      <td>{row.encl}</td>
                      <td>{row.bal}</td>
                      <td>{row.total}</td>
                      <td className="bold-sqft">{row.sqft}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>
  );
};

export default FloorPlan;